import React from "react";

import { NextImage } from "@/components/NextImage";
import { Typography } from "@/components/Typography";
import { I_LoginPage } from "@/data/types/pages";

import "./styles.scss";

export const LoginImage = ({ data }: { data: I_LoginPage }) => {
  const { src, alt, width, height, title } = data.loginImage;

  return (
    <div className="login-image-container">
      <NextImage
        src={src}
        alt={alt}
        width={width}
        height={height}
      />
      <Typography
        Tag="h1"
        classname="login-image-title"
      >
        {title}
      </Typography>
    </div>
  );
};
